// En dev (o si el API se sirve en el mismo origen) se usa la ruta relativa con el
// proxy de Vite. En producción (panel en Cloudflare Pages, API en Railway) se
// inyecta la URL absoluta del API vía VITE_API_URL en el build.
export const API_BASE_URL = import.meta.env.VITE_API_URL ?? '/api/v1';
export const STORAGE_KEYS = {
    ACCESS_TOKEN: 'aa_access_token',
    REFRESH_TOKEN: 'aa_refresh_token',
    TOKEN_EXPIRES_AT: 'aa_token_expires_at',
    USER: 'aa_user',
    THEME: 'aa_theme',
};
export const ROUTES = {
    LOGIN: '/login',
    ONBOARDING: '/onboarding',
    RESET_PASSWORD: '/reset-password',
    CHANGE_PASSWORD: '/change-password',
    DASHBOARD: '/',
    // Director
    DIRECTOR_HOME: '/director/inicio',
    DIRECTOR_STUDENTS: '/director/alumnos',
    DIRECTOR_PROFESSORS: '/director/profesores',
    DIRECTOR_PROSPECTS: '/director/posibles-alumnos',
    DIRECTOR_PAYMENTS: '/director/pagos',
    DIRECTOR_SCHEDULES: '/director/horarios',
    DIRECTOR_MATERIALS: '/director/materiales',
    DIRECTOR_RECORDINGS: '/director/grabaciones',
    DIRECTOR_ANNOUNCEMENTS: '/director/convocatorias',
    DIRECTOR_BLOG: '/director/blog',
    DIRECTOR_APPROVED: '/director/aprobados',
    DIRECTOR_REQUESTS: '/director/solicitudes',
    DIRECTOR_AUDIT: '/director/auditoria',
    DIRECTOR_NOTIFICATIONS: '/director/notificaciones',
    DIRECTOR_CODIFIED_GUIDE: '/director/guia-codificada',
    DIRECTOR_PENAL_CODE: '/director/codigo-penal',
    DIRECTOR_CONSTITUTION: '/director/constitucion',
    // Professor
    PROFESSOR_HOME: '/profesor/inicio',
    PROFESSOR_CLASSES: '/profesor/mis-clases',
    PROFESSOR_MATERIALS: '/profesor/materiales',
    PROFESSOR_PAYMENTS: '/profesor/cobros',
    PROFESSOR_BLOG: '/profesor/blog',
    PROFESSOR_CODIFIED_GUIDE: '/profesor/guia-codificada',
    PROFESSOR_PENAL_CODE: '/profesor/codigo-penal',
    PROFESSOR_CONSTITUTION: '/profesor/constitucion',
    PROFESSOR_SUPPORT: '/profesor/soporte',
    PROFESSOR_NOTIFICATIONS: '/profesor/notificaciones',
    // Student
    STUDENT_DASHBOARD: '/alumno/inicio',
    STUDENT_SCHEDULE: '/alumno/horario',
    STUDENT_MATERIALS: '/alumno/materiales',
    STUDENT_RECORDINGS: '/alumno/grabaciones',
    STUDENT_TESTS: '/alumno/tests',
    STUDENT_ATTENDANCE: '/alumno/asistencia',
    STUDENT_PAYMENTS: '/alumno/pagos',
    STUDENT_REQUESTS: '/alumno/solicitudes',
    STUDENT_NOTIFICATIONS: '/alumno/notificaciones',
    STUDENT_PROFILE: '/alumno/perfil',
    STUDENT_CODIFIED_GUIDE: '/alumno/guia-codificada',
    STUDENT_PENAL_CODE: '/alumno/codigo-penal',
    STUDENT_CONSTITUTION: '/alumno/constitucion',
    STUDENT_SUPPORT: '/alumno/soporte',
    // Director ficha 360
    DIRECTOR_STUDENT_DETAIL: '/director/alumnos/$id',
    // Professor (búsqueda + lista limitada)
    PROFESSOR_STUDENTS: '/profesor/alumnos',
    // Support (consola de incidencias técnicas)
    SUPPORT_INBOX: '/soporte/incidencias',
};
//# sourceMappingURL=constants.js.map